import {ActivatedRouteSnapshot} from '@angular/router';


export function getFullRouterPath(route: ActivatedRouteSnapshot): string {
  return route.pathFromRoot.map(v => v.url.map(segment => segment.toString()).join('/')).join('/');
}
